<div class="container role-manage">
    <div class="heading d-flex">
        <div class="page-title">
            <div>
                <span class="page-title"><h1>Manage Permissions</h1></span>
            </div>
        </div>
        <div *ngIf="formSubmitError" class="row alertContainer" role="alert">
            <div class="col-md-12">
                <div class="alert alert-danger" id="formSubmitError">
                {{ formSubmitError }}
                </div>
            </div>
        </div>
    </div>
    
    <div class="instructions" *ngIf="ischeckPermissions('UpdatePermissions')">
        <span>Select the permission for the corresponding roles</span>        
    </div>

    <div class="permissions-table-container" *ngIf="ischeckPermissions('UpdatePermissions')">
        <table class="permissions-table">
            <thead>
                <tr>
                    <th class="permission-name-header">
                        <span class="user-icon"><em class="fas fa-user"></em></span>
                        Permission Name
                    </th>
                    <th class="role-header">
                        <span class="header-icon"><em class="fas fa-unlock"></em></span>
                        Super Admin
                    </th>
                    <th class="role-header">
                        <span class="header-icon"><em class="fas fa-unlock"></em></span>
                        Admin
                    </th>
                    <th class="role-header">
                        <span class="header-icon"><em class="fas fa-unlock"></em></span>
                        Moderator
                    </th>
                    <th class="role-header">
                        <span class="header-icon"><em class="fas fa-unlock"></em></span>
                        User
                    </th>
                    <th class="role-header wide-header">
                        <span class="header-icon"><em class="fas fa-unlock"></em></span>
                        Casey (TA)
                    </th>
                    <th class="role-header">
                        <span class="header-icon"><em class="fas fa-unlock"></em></span>
                        State (TA)
                    </th>
                    <th class="role-header">
                        <span class="header-icon"><em class="fas fa-unlock"></em></span>
                        Survey Report Viewer
                    </th>
                    <th class="role-header wide-header">
                        <span class="header-icon"><em class="fas fa-unlock"></em></span>
                        Quant Data Viewer
                    </th>
                    <th class="role-header">
                        <span class="header-icon"><em class="fas fa-unlock"></em></span>
                        Quant Data Owner
                    </th>
                    <th class="role-header wide-header">
                        <span class="header-icon"><em class="fas fa-unlock"></em></span>
                        Casey All Sites
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let permission of permissionsAssignment | keyvalue; let rowIndex=index;" class="permission-row">
                    <td class="permission-name">
                        <span [tooltip]="permission.key">{{ permission.key }}</span>
                    </td>
                    <td class="role-checkbox">
                        <input 
                            [ngModel]="checkPermission(permission.value, 'SuperAdmin')" 
                            (change)="checkboxSelect($event, permission.value, permission.key, 'SuperAdmin')" 
                            class="selectCheck" 
                            [value]="userRoles.SuperAdmin" 
                            name="{{permission.key}}" 
                            id="btn-{{rowIndex}}-superadmin"
                            type="checkbox">
                    </td>
                    <td class="role-checkbox">
                        <input 
                            [ngModel]="checkPermission(permission.value, 'Admin')" 
                            (change)="checkboxSelect($event, permission.value, permission.key, 'Admin')" 
                            class="selectCheck" 
                            [value]="userRoles.Admin" 
                            name="{{permission.key}}" 
                            id="btn-{{rowIndex}}-admin"
                            type="checkbox">
                    </td>
                    <td class="role-checkbox">
                        <input 
                            [ngModel]="checkPermission(permission.value, 'Moderator')" 
                            (change)="checkboxSelect($event, permission.value, permission.key, 'Moderator')" 
                            class="selectCheck" 
                            [value]="userRoles.Moderator" 
                            name="{{permission.key}}" 
                            id="btn-{{rowIndex}}-moderator"
                            type="checkbox">
                    </td>
                    <td class="role-checkbox">
                        <input 
                            [ngModel]="checkPermission(permission.value, 'User')" 
                            (change)="checkboxSelect($event, permission.value, permission.key, 'User')" 
                            class="selectCheck" 
                            [value]="userRoles.User" 
                            name="{{permission.key}}" 
                            id="btn-{{rowIndex}}-user"
                            type="checkbox">
                    </td>
                    <td class="role-checkbox">
                        <input 
                            [ngModel]="checkPermission(permission.value, 'CaseyTA')" 
                            (change)="checkboxSelect($event, permission.value, permission.key, 'CaseyTA')" 
                            class="selectCheck" 
                            [value]="userRoles.CaseyTA" 
                            name="{{permission.key}}" 
                            id="btn-{{rowIndex}}-CaseyTA"
                            type="checkbox">
                    </td>
                    <td class="role-checkbox">
                        <input 
                            [ngModel]="checkPermission(permission.value, 'State')" 
                            (change)="checkboxSelect($event, permission.value, permission.key, 'State')" 
                            class="selectCheck" 
                            [value]="userRoles.State" 
                            name="{{permission.key}}" 
                            id="btn-{{rowIndex}}-State"
                            type="checkbox">
                    </td>
                    <td class="role-checkbox">
                        <input 
                            [ngModel]="checkPermission(permission.value, 'SurveyReportViewer')" 
                            (change)="checkboxSelect($event, permission.value, permission.key, 'SurveyReportViewer')" 
                            class="selectCheck" 
                            [value]="userRoles.SurveyReportViewer" 
                            name="{{permission.key}}" 
                            id="btn-{{rowIndex}}-SurveyReportViewer"
                            type="checkbox">
                    </td>
                    <td class="role-checkbox">
                        <input 
                            [ngModel]="checkPermission(permission.value, 'QuantDataViewer')" 
                            (change)="checkboxSelect($event, permission.value, permission.key, 'QuantDataViewer')" 
                            class="selectCheck" 
                            [value]="userRoles.QuantDataViewer" 
                            name="{{permission.key}}" 
                            id="btn-{{rowIndex}}-QuantDataViewer"
                            type="checkbox">
                    </td>
                    <td class="role-checkbox">
                        <input 
                            [ngModel]="checkPermission(permission.value, 'QuantDataOwner')" 
                            (change)="checkboxSelect($event, permission.value, permission.key, 'QuantDataOwner')" 
                            class="selectCheck" 
                            [value]="userRoles.QuantDataOwner" 
                            name="{{permission.key}}" 
                            id="btn-{{rowIndex}}-QuantDataOwner"
                            type="checkbox">
                    </td>
                    <td class="role-checkbox">
                        <input 
                            [ngModel]="checkPermission(permission.value, 'CaseyAllSites')" 
                            (change)="checkboxSelect($event, permission.value, permission.key, 'CaseyAllSites')" 
                            class="selectCheck" 
                            [value]="userRoles.CaseyAllSites" 
                            name="{{permission.key}}" 
                            id="btn-{{rowIndex}}-CaseyAllSites"
                            type="checkbox">
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    
    <div class="action-buttons">
        <div class="button-group">
            <button type="button" id="btncancel" class="btn btn-secondary button-style back-button" [routerLink]="['/']">
                Cancel
            </button>
            <button type="button" id="btnsave" class="btn btn-secondary button-style" (click)="updatePermission()">
                Save
            </button>
        </div>
        <div class="success-message" *ngIf="formSubmitSuccess">
            <alert type="success" class="toast" [dismissible]="true" [dismissOnTimeout]="5000">
                {{formSubmitSuccess}}
            </alert>
        </div>
    </div>
</div>